/* eslint-disable */
import { standardLogin, logoutApi, getCurrentUser } from '@/views/login/service';
import Cookies from 'js-cookie';
import { setStorage, getStorage, removeStorage } from '@/libs/utils/index.js'
import {getCurrentMenu} from "@/api/service";
import {getConstantRouterMap} from "@/router/modules";
import router from "../../router";

const user = {
  state: {
    token: '',
    userInfo: {}, // 当前用户信息
    routeRole: JSON.parse(getStorage('routeRole')),
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_ROUTE_ROLE: (state, routeRole) => {
      state.routeRole = routeRole
    },
  },
  actions: {
    login: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        standardLogin(data).then((res) => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // 用户信息
    getUserInfo: ({ commit }) => {
      return new Promise(async (resolve, reject) => {
        let res = await getCurrentUser();
        commit('SET_USER_INFO', res.data);
        let resM = await getCurrentMenu();
        const menu = resM.data || [];
        setStorage('routeRole', menu);
        const routes = getConstantRouterMap();
        resolve(routes);
      })
    },
    // 退出登录
    logOut: ({ commit }) => {
      return new Promise(async (resolve, reject) => {
        commit('SET_ROUTE_ROLE', '')
        try {
          await logoutApi();
          Cookies.remove('cmsweb');
        } catch (e) {
          Cookies.remove('cmsweb');
        }
        resolve();
      })
    }
  }
}

export default user
